import type { CSSProperties } from "react";
import "./home-button.css";

interface HomeButtonProps {
  onClick: () => void;
  className?: string;
}

export default function HomeButton({ onClick, className }: HomeButtonProps) {
  return (
    <button
      type="button"
      className={["exms-home-button", className].filter(Boolean).join(" ")}
      onClick={onClick}
      title="Home"
      aria-label="Home"
      style={homeButtonStyle}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M3 12l9-9 9 9" />
        <path d="M9 21V12h6v9" />
      </svg>
    </button>
  );
}

const homeButtonStyle: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 36,
  height: 36,
  borderRadius: 999,
  border: "1px solid var(--dialog-border-color)",
  background: "var(--exms-toolbar-hover, var(--island-bg-color))",
  color: "var(--text-primary-color)",
  cursor: "pointer",
  padding: 0,
};
